window.Croppr = require('croppr');
// window.Croppic = require('croppic-js');
// console.log('window.Croppic', window.Croppic);
/*
function traitementAvantEnvois(params)
{
    console.log('traitementAvantEnvois', params);
}
function traitementSiReussite(params)
{
    console.log('traitementSiReussite', params);
}
function taitementSiEchec(params)
{
    console.log('taitementSiEchec', params);
}

$('#file-upload').on('submit', function(e){
    e.preventDefault();
    e.stopPropagation();
    $.ajax({
        url: 'image/upload',
        method: 'POST',
        data: new FormData(this),
        dataType: 'json',
        contentType: false,
        cache: false,
        processData: false,
        success:function(data)
        {
            console.log('data', data);
            $('#message').css('display', 'block');
            $('#message').html(data.message);
            $('#message').addClass(data.class_name);
            $('#uploaded_image').html(data.uploaded_image);
        }
    })
});

$('.upload').change(function (e) {
    $('#file-upload').submit();
    /*
    console.log('upload change', e);

    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });
    var formData = new FormData($("#file-upload")[0]);
    // var formulaire = new FormData($('#file-upload')[0]);
    $.ajax({
        url: 'image/upload', //script qui traitera l'envoi du fichier
        type: 'POST',
        xhr: function () { // xhr qui traite la barre de progression
            myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) { // vérifie si l'upload existe
                myXhr.upload.addEventListener('progress', afficherAvancement, false); // Pour ajouter l'évènement progress sur l'upload de fichier
            }
            return myXhr;
        },
        //Traitements AJAX
        beforeSend: traitementAvantEnvois,
        success: traitementSiReussite,
        error: taitementSiEchec,
        //Données du formulaire envoyé
        data: formData,
        //Options signifiant à jQuery de ne pas s'occuper du type de données
        cache: false,
        contentType: false,
        processData: false
    });
    function afficherAvancement(e) {
        if (e.lengthComputable) {
            $('progress').attr({ value: e.loaded, max: e.total });
        }
    }
    *//*
});
*/
